// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/graph.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ArrowType } from "../../arrow/v1/arrow_pb";
import { file_chalk_arrow_v1_arrow } from "../../arrow/v1/arrow_pb";
import type { ExportDiff } from "../../artifacts/v1/diff_pb";
import { file_chalk_artifacts_v1_diff } from "../../artifacts/v1/diff_pb";
import type { Export } from "../../artifacts/v1/export_pb";
import { file_chalk_artifacts_v1_export } from "../../artifacts/v1/export_pb";
import { file_chalk_auth_v1_permissions } from "../../auth/v1/permissions_pb";
import type { ChalkError } from "../../common/v1/chalk_error_pb";
import { file_chalk_common_v1_chalk_error } from "../../common/v1/chalk_error_pb";
import type { FeatureSet, FeatureType, Graph, Resolver, StreamResolver } from "../../graph/v1/graph_pb";
import { file_chalk_graph_v1_graph } from "../../graph/v1/graph_pb";
import type { FieldMask } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/server/v1/graph.proto.
 */
export const file_chalk_server_v1_graph: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_arrow_v1_arrow, file_chalk_artifacts_v1_diff, file_chalk_artifacts_v1_export, file_chalk_auth_v1_permissions, file_chalk_common_v1_chalk_error, file_chalk_graph_v1_graph, file_google_protobuf_field_mask]);

/**
 * @generated from message chalk.server.v1.FeatureSQL
 */
export type FeatureSQL = Message<"chalk.server.v1.FeatureSQL"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string environment_id = 2;
   */
  environmentId: string;

  /**
   * @generated from field: optional string deployment_id = 3;
   */
  deploymentId?: string;

  /**
   * @generated from field: string fqn = 4;
   */
  fqn: string;

  /**
   * @generated from field: string name = 5;
   */
  name: string;

  /**
   * @generated from field: string namespace = 6;
   */
  namespace: string;

  /**
   * @generated from field: optional string max_staleness = 7;
   */
  maxStaleness?: string;

  /**
   * @generated from field: bool etl_offline_to_online = 8;
   */
  etlOfflineToOnline: boolean;

  /**
   * @generated from field: optional string description = 9;
   */
  description?: string;

  /**
   * @generated from field: optional string owner = 10;
   */
  owner?: string;

  /**
   * @generated from field: repeated string tags = 11;
   */
  tags: string[];

  /**
   * @generated from field: string kind_enum = 12;
   */
  kindEnum: string;

  /**
   * @generated from field: string kind = 13;
   */
  kind: string;

  /**
   * @generated from field: bool was_reset = 14;
   */
  wasReset: boolean;

  /**
   * @generated from field: optional int64 internal_version = 15;
   */
  internalVersion?: bigint;

  /**
   *  string created_at = 14;
   *  string updated_at = 15;
   *
   * @generated from field: bool is_singleton = 16;
   */
  isSingleton: boolean;
};

/**
 * Describes the message chalk.server.v1.FeatureSQL.
 * Use `create(FeatureSQLSchema)` to create a new message.
 */
export const FeatureSQLSchema: GenMessage<FeatureSQL> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 0);

/**
 * @generated from message chalk.server.v1.GetFeatureSQLResponse
 */
export type GetFeatureSQLResponse = Message<"chalk.server.v1.GetFeatureSQLResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.FeatureSQL features = 1;
   */
  features: FeatureSQL[];
};

/**
 * Describes the message chalk.server.v1.GetFeatureSQLResponse.
 * Use `create(GetFeatureSQLResponseSchema)` to create a new message.
 */
export const GetFeatureSQLResponseSchema: GenMessage<GetFeatureSQLResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 1);

/**
 * @generated from message chalk.server.v1.GetFeatureSQLRequest
 */
export type GetFeatureSQLRequest = Message<"chalk.server.v1.GetFeatureSQLRequest"> & {
  /**
   * @generated from field: string deployment_id = 1;
   */
  deploymentId: string;
};

/**
 * Describes the message chalk.server.v1.GetFeatureSQLRequest.
 * Use `create(GetFeatureSQLRequestSchema)` to create a new message.
 */
export const GetFeatureSQLRequestSchema: GenMessage<GetFeatureSQLRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 2);

/**
 * @generated from message chalk.server.v1.FeatureMetadata
 */
export type FeatureMetadata = Message<"chalk.server.v1.FeatureMetadata"> & {
  /**
   * @generated from field: string fqn = 1;
   */
  fqn: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string namespace = 3;
   */
  namespace: string;

  /**
   * @generated from field: optional string description = 4;
   */
  description?: string;

  /**
   * @generated from field: optional string owner = 5;
   */
  owner?: string;

  /**
   * @generated from field: repeated string tags = 6;
   */
  tags: string[];

  /**
   * @generated from field: optional string max_staleness = 7;
   */
  maxStaleness?: string;

  /**
   * @generated from field: bool etl_offline_to_online = 8;
   */
  etlOfflineToOnline: boolean;

  /**
   * @generated from field: chalk.arrow.v1.ArrowType pa_dtype = 9;
   */
  paDtype?: ArrowType;

  /**
   * @generated from field: bool nullable = 10;
   */
  nullable: boolean;
};

/**
 * Describes the message chalk.server.v1.FeatureMetadata.
 * Use `create(FeatureMetadataSchema)` to create a new message.
 */
export const FeatureMetadataSchema: GenMessage<FeatureMetadata> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 3);

/**
 * @generated from message chalk.server.v1.GetFeaturesMetadataResponse
 */
export type GetFeaturesMetadataResponse = Message<"chalk.server.v1.GetFeaturesMetadataResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.FeatureMetadata features = 1;
   */
  features: FeatureMetadata[];

  /**
   * @generated from field: string environment_id = 2;
   */
  environmentId: string;

  /**
   * @generated from field: string deployment_id = 3;
   */
  deploymentId: string;
};

/**
 * Describes the message chalk.server.v1.GetFeaturesMetadataResponse.
 * Use `create(GetFeaturesMetadataResponseSchema)` to create a new message.
 */
export const GetFeaturesMetadataResponseSchema: GenMessage<GetFeaturesMetadataResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 4);

/**
 * @generated from message chalk.server.v1.GetFeaturesMetadataRequest
 */
export type GetFeaturesMetadataRequest = Message<"chalk.server.v1.GetFeaturesMetadataRequest"> & {
  /**
   * Return one metadata for each feature matching the FQNs in this list.
   * If a feature is not found, an error will be returned.
   *
   * @generated from field: repeated string fqns_filter = 1;
   */
  fqnsFilter: string[];
};

/**
 * Describes the message chalk.server.v1.GetFeaturesMetadataRequest.
 * Use `create(GetFeaturesMetadataRequestSchema)` to create a new message.
 */
export const GetFeaturesMetadataRequestSchema: GenMessage<GetFeaturesMetadataRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 5);

/**
 * @generated from message chalk.server.v1.UpdateGraphRequest
 */
export type UpdateGraphRequest = Message<"chalk.server.v1.UpdateGraphRequest"> & {
  /**
   * @generated from field: string deployment_id = 1;
   */
  deploymentId: string;

  /**
   * Use Export instead, which includes a graph + additional metadata
   *
   * @generated from field: chalk.graph.v1.Graph graph = 2 [deprecated = true];
   * @deprecated
   */
  graph?: Graph;

  /**
   * @generated from field: string chalkpy_version = 3;
   */
  chalkpyVersion: string;

  /**
   * @generated from field: optional string tag = 4;
   */
  tag?: string;

  /**
   * @generated from field: chalk.artifacts.v1.Export export = 5;
   */
  export?: Export;
};

/**
 * Describes the message chalk.server.v1.UpdateGraphRequest.
 * Use `create(UpdateGraphRequestSchema)` to create a new message.
 */
export const UpdateGraphRequestSchema: GenMessage<UpdateGraphRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 6);

/**
 * @generated from message chalk.server.v1.UpdateGraphResponse
 */
export type UpdateGraphResponse = Message<"chalk.server.v1.UpdateGraphResponse"> & {
};

/**
 * Describes the message chalk.server.v1.UpdateGraphResponse.
 * Use `create(UpdateGraphResponseSchema)` to create a new message.
 */
export const UpdateGraphResponseSchema: GenMessage<UpdateGraphResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 7);

/**
 * Per-request tuning for GetGraph. Every field defaults false (the full graph,
 * backward compatible); set a flag to omit that subtree from the bulk graph.
 *
 * @generated from message chalk.server.v1.GraphFetchOptions
 */
export type GraphFetchOptions = Message<"chalk.server.v1.GraphFetchOptions"> & {
  /**
   * Omit Resolver.postprocessing — a large expression tree only rendered on a
   * single resolver's detail view, fetched on demand via GetResolver.
   * The dashboard's bulk graph load sets this.
   *
   * @generated from field: bool exclude_resolver_postprocessing = 1;
   */
  excludeResolverPostprocessing: boolean;

  /**
   * Omit StreamResolver.parse_info, fetched on demand via GetStreamResolver.
   *
   * @generated from field: bool exclude_stream_resolver_parse_info = 2;
   */
  excludeStreamResolverParseInfo: boolean;
};

/**
 * Describes the message chalk.server.v1.GraphFetchOptions.
 * Use `create(GraphFetchOptionsSchema)` to create a new message.
 */
export const GraphFetchOptionsSchema: GenMessage<GraphFetchOptions> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 8);

/**
 * @generated from message chalk.server.v1.GetGraphRequest
 */
export type GetGraphRequest = Message<"chalk.server.v1.GetGraphRequest"> & {
  /**
   * @generated from field: string deployment_id = 1;
   */
  deploymentId: string;

  /**
   * Absent = full graph (backward compatible). Kept distinct from an empty
   * GraphFetchOptions so a future default (e.g. excluding by default) stays expressible.
   *
   * @generated from field: optional chalk.server.v1.GraphFetchOptions fetch_options = 2;
   */
  fetchOptions?: GraphFetchOptions;
};

/**
 * Describes the message chalk.server.v1.GetGraphRequest.
 * Use `create(GetGraphRequestSchema)` to create a new message.
 */
export const GetGraphRequestSchema: GenMessage<GetGraphRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 9);

/**
 * @generated from message chalk.server.v1.GetGraphResponse
 */
export type GetGraphResponse = Message<"chalk.server.v1.GetGraphResponse"> & {
  /**
   * Use Export instead, which includes a graph + additional metadata
   *
   * @generated from field: chalk.graph.v1.Graph graph = 1 [deprecated = true];
   * @deprecated
   */
  graph?: Graph;

  /**
   * @generated from field: string chalkpy_version = 2;
   */
  chalkpyVersion: string;

  /**
   * @generated from field: optional string tag = 3;
   */
  tag?: string;

  /**
   * @generated from field: chalk.artifacts.v1.Export export = 4;
   */
  export?: Export;

  /**
   * @generated from field: string deployment_id = 5;
   */
  deploymentId: string;
};

/**
 * Describes the message chalk.server.v1.GetGraphResponse.
 * Use `create(GetGraphResponseSchema)` to create a new message.
 */
export const GetGraphResponseSchema: GenMessage<GetGraphResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 10);

/**
 * @generated from message chalk.server.v1.GetResolverRequest
 */
export type GetResolverRequest = Message<"chalk.server.v1.GetResolverRequest"> & {
  /**
   * @generated from field: string deployment_id = 1;
   */
  deploymentId: string;

  /**
   * @generated from field: string resolver_fqn = 2;
   */
  resolverFqn: string;

  /**
   * Absent = the full Resolver. Lets callers fetch just the large sub-trees
   * (e.g. postprocessing) that GetGraph omits from the bulk payload.
   *
   * @generated from field: optional google.protobuf.FieldMask read_mask = 3;
   */
  readMask?: FieldMask;
};

/**
 * Describes the message chalk.server.v1.GetResolverRequest.
 * Use `create(GetResolverRequestSchema)` to create a new message.
 */
export const GetResolverRequestSchema: GenMessage<GetResolverRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 11);

/**
 * @generated from message chalk.server.v1.GetResolverResponse
 */
export type GetResolverResponse = Message<"chalk.server.v1.GetResolverResponse"> & {
  /**
   * @generated from field: chalk.graph.v1.Resolver resolver = 1;
   */
  resolver?: Resolver;
};

/**
 * Describes the message chalk.server.v1.GetResolverResponse.
 * Use `create(GetResolverResponseSchema)` to create a new message.
 */
export const GetResolverResponseSchema: GenMessage<GetResolverResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 12);

/**
 * @generated from message chalk.server.v1.GetStreamResolverRequest
 */
export type GetStreamResolverRequest = Message<"chalk.server.v1.GetStreamResolverRequest"> & {
  /**
   * @generated from field: string deployment_id = 1;
   */
  deploymentId: string;

  /**
   * @generated from field: string resolver_fqn = 2;
   */
  resolverFqn: string;

  /**
   * Absent = the full StreamResolver. Lets callers fetch just the large sub-trees
   * (e.g. parse_info) that GetGraph omits from the bulk payload.
   *
   * @generated from field: optional google.protobuf.FieldMask read_mask = 3;
   */
  readMask?: FieldMask;
};

/**
 * Describes the message chalk.server.v1.GetStreamResolverRequest.
 * Use `create(GetStreamResolverRequestSchema)` to create a new message.
 */
export const GetStreamResolverRequestSchema: GenMessage<GetStreamResolverRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 13);

/**
 * @generated from message chalk.server.v1.GetStreamResolverResponse
 */
export type GetStreamResolverResponse = Message<"chalk.server.v1.GetStreamResolverResponse"> & {
  /**
   * @generated from field: chalk.graph.v1.StreamResolver stream_resolver = 1;
   */
  streamResolver?: StreamResolver;
};

/**
 * Describes the message chalk.server.v1.GetStreamResolverResponse.
 * Use `create(GetStreamResolverResponseSchema)` to create a new message.
 */
export const GetStreamResolverResponseSchema: GenMessage<GetStreamResolverResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 14);

/**
 * @generated from message chalk.server.v1.PythonVersion
 */
export type PythonVersion = Message<"chalk.server.v1.PythonVersion"> & {
  /**
   * @generated from field: int64 major = 1;
   */
  major: bigint;

  /**
   * @generated from field: int64 minor = 2;
   */
  minor: bigint;

  /**
   * @generated from field: int64 patch = 3;
   */
  patch: bigint;
};

/**
 * Describes the message chalk.server.v1.PythonVersion.
 * Use `create(PythonVersionSchema)` to create a new message.
 */
export const PythonVersionSchema: GenMessage<PythonVersion> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 15);

/**
 * @generated from message chalk.server.v1.GetCodegenFeaturesFromGraphRequest
 */
export type GetCodegenFeaturesFromGraphRequest = Message<"chalk.server.v1.GetCodegenFeaturesFromGraphRequest"> & {
  /**
   * @generated from field: optional string deployment_id = 1;
   */
  deploymentId?: string;

  /**
   * @generated from field: optional string branch = 2;
   */
  branch?: string;

  /**
   * @generated from field: optional chalk.server.v1.PythonVersion python_version = 3;
   */
  pythonVersion?: PythonVersion;
};

/**
 * Describes the message chalk.server.v1.GetCodegenFeaturesFromGraphRequest.
 * Use `create(GetCodegenFeaturesFromGraphRequestSchema)` to create a new message.
 */
export const GetCodegenFeaturesFromGraphRequestSchema: GenMessage<GetCodegenFeaturesFromGraphRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 16);

/**
 * @generated from message chalk.server.v1.GetCodegenFeaturesFromGraphResponse
 */
export type GetCodegenFeaturesFromGraphResponse = Message<"chalk.server.v1.GetCodegenFeaturesFromGraphResponse"> & {
  /**
   * @generated from field: string codegen = 1;
   */
  codegen: string;

  /**
   * @generated from field: repeated chalk.common.v1.ChalkError errors = 2;
   */
  errors: ChalkError[];
};

/**
 * Describes the message chalk.server.v1.GetCodegenFeaturesFromGraphResponse.
 * Use `create(GetCodegenFeaturesFromGraphResponseSchema)` to create a new message.
 */
export const GetCodegenFeaturesFromGraphResponseSchema: GenMessage<GetCodegenFeaturesFromGraphResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 17);

/**
 * GraphMutation represents a single mutation to apply to the graph
 *
 * @generated from message chalk.server.v1.GraphMutation
 */
export type GraphMutation = Message<"chalk.server.v1.GraphMutation"> & {
  /**
   * @generated from oneof chalk.server.v1.GraphMutation.mutation
   */
  mutation: {
    /**
     * @generated from field: chalk.server.v1.AddStreamingResolver add_streaming_resolver = 1;
     */
    value: AddStreamingResolver;
    case: "addStreamingResolver";
  } | {
    /**
     * @generated from field: chalk.server.v1.UpdateStreamingResolver update_streaming_resolver = 2;
     */
    value: UpdateStreamingResolver;
    case: "updateStreamingResolver";
  } | {
    /**
     * @generated from field: chalk.server.v1.DeleteStreamingResolver delete_streaming_resolver = 3;
     */
    value: DeleteStreamingResolver;
    case: "deleteStreamingResolver";
  } | {
    /**
     * @generated from field: chalk.server.v1.AddFeature add_feature = 4;
     */
    value: AddFeature;
    case: "addFeature";
  } | {
    /**
     * @generated from field: chalk.server.v1.UpdateFeature update_feature = 5;
     */
    value: UpdateFeature;
    case: "updateFeature";
  } | {
    /**
     * @generated from field: chalk.server.v1.DeleteFeature delete_feature = 6;
     */
    value: DeleteFeature;
    case: "deleteFeature";
  } | {
    /**
     * @generated from field: chalk.server.v1.AddFeatureSet add_feature_set = 7;
     */
    value: AddFeatureSet;
    case: "addFeatureSet";
  } | {
    /**
     * @generated from field: chalk.server.v1.UpdateFeatureSet update_feature_set = 8;
     */
    value: UpdateFeatureSet;
    case: "updateFeatureSet";
  } | {
    /**
     * @generated from field: chalk.server.v1.DeleteFeatureSet delete_feature_set = 9;
     */
    value: DeleteFeatureSet;
    case: "deleteFeatureSet";
  } | {
    /**
     * @generated from field: chalk.server.v1.AddResolver add_resolver = 10;
     */
    value: AddResolver;
    case: "addResolver";
  } | {
    /**
     * @generated from field: chalk.server.v1.UpdateResolver update_resolver = 11;
     */
    value: UpdateResolver;
    case: "updateResolver";
  } | {
    /**
     * @generated from field: chalk.server.v1.DeleteResolver delete_resolver = 12;
     */
    value: DeleteResolver;
    case: "deleteResolver";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.server.v1.GraphMutation.
 * Use `create(GraphMutationSchema)` to create a new message.
 */
export const GraphMutationSchema: GenMessage<GraphMutation> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 18);

/**
 * Streaming Resolver mutations
 *
 * @generated from message chalk.server.v1.AddStreamingResolver
 */
export type AddStreamingResolver = Message<"chalk.server.v1.AddStreamingResolver"> & {
  /**
   * @generated from field: chalk.graph.v1.StreamResolver resolver = 1;
   */
  resolver?: StreamResolver;
};

/**
 * Describes the message chalk.server.v1.AddStreamingResolver.
 * Use `create(AddStreamingResolverSchema)` to create a new message.
 */
export const AddStreamingResolverSchema: GenMessage<AddStreamingResolver> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 19);

/**
 * @generated from message chalk.server.v1.UpdateStreamingResolver
 */
export type UpdateStreamingResolver = Message<"chalk.server.v1.UpdateStreamingResolver"> & {
  /**
   * FQN of the resolver
   *
   * @generated from field: string resolver_name = 1;
   */
  resolverName: string;

  /**
   * @generated from field: chalk.graph.v1.StreamResolver resolver = 2;
   */
  resolver?: StreamResolver;
};

/**
 * Describes the message chalk.server.v1.UpdateStreamingResolver.
 * Use `create(UpdateStreamingResolverSchema)` to create a new message.
 */
export const UpdateStreamingResolverSchema: GenMessage<UpdateStreamingResolver> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 20);

/**
 * @generated from message chalk.server.v1.DeleteStreamingResolver
 */
export type DeleteStreamingResolver = Message<"chalk.server.v1.DeleteStreamingResolver"> & {
  /**
   * FQN of the resolver
   *
   * @generated from field: string resolver_name = 1;
   */
  resolverName: string;
};

/**
 * Describes the message chalk.server.v1.DeleteStreamingResolver.
 * Use `create(DeleteStreamingResolverSchema)` to create a new message.
 */
export const DeleteStreamingResolverSchema: GenMessage<DeleteStreamingResolver> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 21);

/**
 * Resolver (non-streaming) mutations
 *
 * @generated from message chalk.server.v1.AddResolver
 */
export type AddResolver = Message<"chalk.server.v1.AddResolver"> & {
  /**
   * @generated from field: chalk.graph.v1.Resolver resolver = 1;
   */
  resolver?: Resolver;
};

/**
 * Describes the message chalk.server.v1.AddResolver.
 * Use `create(AddResolverSchema)` to create a new message.
 */
export const AddResolverSchema: GenMessage<AddResolver> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 22);

/**
 * @generated from message chalk.server.v1.UpdateResolver
 */
export type UpdateResolver = Message<"chalk.server.v1.UpdateResolver"> & {
  /**
   * FQN of the resolver
   *
   * @generated from field: string resolver_name = 1;
   */
  resolverName: string;

  /**
   * @generated from field: chalk.graph.v1.Resolver resolver = 2;
   */
  resolver?: Resolver;
};

/**
 * Describes the message chalk.server.v1.UpdateResolver.
 * Use `create(UpdateResolverSchema)` to create a new message.
 */
export const UpdateResolverSchema: GenMessage<UpdateResolver> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 23);

/**
 * @generated from message chalk.server.v1.DeleteResolver
 */
export type DeleteResolver = Message<"chalk.server.v1.DeleteResolver"> & {
  /**
   * FQN of the resolver
   *
   * @generated from field: string resolver_name = 1;
   */
  resolverName: string;
};

/**
 * Describes the message chalk.server.v1.DeleteResolver.
 * Use `create(DeleteResolverSchema)` to create a new message.
 */
export const DeleteResolverSchema: GenMessage<DeleteResolver> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 24);

/**
 * Feature mutations
 *
 * @generated from message chalk.server.v1.AddFeature
 */
export type AddFeature = Message<"chalk.server.v1.AddFeature"> & {
  /**
   * namespace
   *
   * @generated from field: string feature_set_name = 1;
   */
  featureSetName: string;

  /**
   * @generated from field: chalk.graph.v1.FeatureType feature = 2;
   */
  feature?: FeatureType;
};

/**
 * Describes the message chalk.server.v1.AddFeature.
 * Use `create(AddFeatureSchema)` to create a new message.
 */
export const AddFeatureSchema: GenMessage<AddFeature> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 25);

/**
 * @generated from message chalk.server.v1.UpdateFeature
 */
export type UpdateFeature = Message<"chalk.server.v1.UpdateFeature"> & {
  /**
   * featureset_name.feature_name
   *
   * @generated from field: string fqn = 1;
   */
  fqn: string;

  /**
   * @generated from field: chalk.graph.v1.FeatureType feature = 2;
   */
  feature?: FeatureType;
};

/**
 * Describes the message chalk.server.v1.UpdateFeature.
 * Use `create(UpdateFeatureSchema)` to create a new message.
 */
export const UpdateFeatureSchema: GenMessage<UpdateFeature> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 26);

/**
 * @generated from message chalk.server.v1.DeleteFeature
 */
export type DeleteFeature = Message<"chalk.server.v1.DeleteFeature"> & {
  /**
   * featureset_name.feature_name
   *
   * @generated from field: string fqn = 1;
   */
  fqn: string;
};

/**
 * Describes the message chalk.server.v1.DeleteFeature.
 * Use `create(DeleteFeatureSchema)` to create a new message.
 */
export const DeleteFeatureSchema: GenMessage<DeleteFeature> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 27);

/**
 * FeatureSet mutations
 *
 * @generated from message chalk.server.v1.AddFeatureSet
 */
export type AddFeatureSet = Message<"chalk.server.v1.AddFeatureSet"> & {
  /**
   * @generated from field: chalk.graph.v1.FeatureSet feature_set = 1;
   */
  featureSet?: FeatureSet;
};

/**
 * Describes the message chalk.server.v1.AddFeatureSet.
 * Use `create(AddFeatureSetSchema)` to create a new message.
 */
export const AddFeatureSetSchema: GenMessage<AddFeatureSet> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 28);

/**
 * @generated from message chalk.server.v1.UpdateFeatureSet
 */
export type UpdateFeatureSet = Message<"chalk.server.v1.UpdateFeatureSet"> & {
  /**
   * @generated from field: string feature_set_name = 1;
   */
  featureSetName: string;

  /**
   * @generated from field: chalk.graph.v1.FeatureSet feature_set = 2;
   */
  featureSet?: FeatureSet;
};

/**
 * Describes the message chalk.server.v1.UpdateFeatureSet.
 * Use `create(UpdateFeatureSetSchema)` to create a new message.
 */
export const UpdateFeatureSetSchema: GenMessage<UpdateFeatureSet> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 29);

/**
 * @generated from message chalk.server.v1.DeleteFeatureSet
 */
export type DeleteFeatureSet = Message<"chalk.server.v1.DeleteFeatureSet"> & {
  /**
   * @generated from field: string feature_set_name = 1;
   */
  featureSetName: string;
};

/**
 * Describes the message chalk.server.v1.DeleteFeatureSet.
 * Use `create(DeleteFeatureSetSchema)` to create a new message.
 */
export const DeleteFeatureSetSchema: GenMessage<DeleteFeatureSet> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 30);

/**
 * @generated from message chalk.server.v1.ApplyGraphUpdatesRequest
 */
export type ApplyGraphUpdatesRequest = Message<"chalk.server.v1.ApplyGraphUpdatesRequest"> & {
  /**
   * @generated from field: string deployment_id = 1;
   */
  deploymentId: string;

  /**
   * @generated from field: repeated chalk.server.v1.GraphMutation mutations = 2;
   */
  mutations: GraphMutation[];
};

/**
 * Describes the message chalk.server.v1.ApplyGraphUpdatesRequest.
 * Use `create(ApplyGraphUpdatesRequestSchema)` to create a new message.
 */
export const ApplyGraphUpdatesRequestSchema: GenMessage<ApplyGraphUpdatesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 31);

/**
 * @generated from message chalk.server.v1.ApplyGraphUpdatesResponse
 */
export type ApplyGraphUpdatesResponse = Message<"chalk.server.v1.ApplyGraphUpdatesResponse"> & {
};

/**
 * Describes the message chalk.server.v1.ApplyGraphUpdatesResponse.
 * Use `create(ApplyGraphUpdatesResponseSchema)` to create a new message.
 */
export const ApplyGraphUpdatesResponseSchema: GenMessage<ApplyGraphUpdatesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 32);

/**
 * @generated from message chalk.server.v1.TestGraphMutationsRequest
 */
export type TestGraphMutationsRequest = Message<"chalk.server.v1.TestGraphMutationsRequest"> & {
  /**
   * @generated from field: string deployment_id = 1;
   */
  deploymentId: string;

  /**
   * @generated from field: repeated chalk.server.v1.GraphMutation mutations = 2;
   */
  mutations: GraphMutation[];
};

/**
 * Describes the message chalk.server.v1.TestGraphMutationsRequest.
 * Use `create(TestGraphMutationsRequestSchema)` to create a new message.
 */
export const TestGraphMutationsRequestSchema: GenMessage<TestGraphMutationsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 33);

/**
 * @generated from message chalk.server.v1.TestGraphMutationsResponse
 */
export type TestGraphMutationsResponse = Message<"chalk.server.v1.TestGraphMutationsResponse"> & {
  /**
   * @generated from field: chalk.artifacts.v1.Export export = 1;
   */
  export?: Export;

  /**
   * @generated from field: repeated chalk.common.v1.ChalkError errors = 2;
   */
  errors: ChalkError[];
};

/**
 * Describes the message chalk.server.v1.TestGraphMutationsResponse.
 * Use `create(TestGraphMutationsResponseSchema)` to create a new message.
 */
export const TestGraphMutationsResponseSchema: GenMessage<TestGraphMutationsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 34);

/**
 * Data Lineage Index types
 *
 * @generated from message chalk.server.v1.ColumnList
 */
export type ColumnList = Message<"chalk.server.v1.ColumnList"> & {
  /**
   * @generated from field: repeated string columns = 1;
   */
  columns: string[];
};

/**
 * Describes the message chalk.server.v1.ColumnList.
 * Use `create(ColumnListSchema)` to create a new message.
 */
export const ColumnListSchema: GenMessage<ColumnList> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 35);

/**
 * @generated from message chalk.server.v1.TableLineage
 */
export type TableLineage = Message<"chalk.server.v1.TableLineage"> & {
  /**
   * @generated from field: map<string, chalk.server.v1.ColumnList> features = 1;
   */
  features: { [key: string]: ColumnList };
};

/**
 * Describes the message chalk.server.v1.TableLineage.
 * Use `create(TableLineageSchema)` to create a new message.
 */
export const TableLineageSchema: GenMessage<TableLineage> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 36);

/**
 * @generated from message chalk.server.v1.DataSourceLineage
 */
export type DataSourceLineage = Message<"chalk.server.v1.DataSourceLineage"> & {
  /**
   * @generated from field: map<string, chalk.server.v1.TableLineage> tables = 1;
   */
  tables: { [key: string]: TableLineage };
};

/**
 * Describes the message chalk.server.v1.DataSourceLineage.
 * Use `create(DataSourceLineageSchema)` to create a new message.
 */
export const DataSourceLineageSchema: GenMessage<DataSourceLineage> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 37);

/**
 * @generated from message chalk.server.v1.ResolverDataLineage
 */
export type ResolverDataLineage = Message<"chalk.server.v1.ResolverDataLineage"> & {
  /**
   * @generated from field: map<string, chalk.server.v1.DataSourceLineage> data_sources = 1;
   */
  dataSources: { [key: string]: DataSourceLineage };
};

/**
 * Describes the message chalk.server.v1.ResolverDataLineage.
 * Use `create(ResolverDataLineageSchema)` to create a new message.
 */
export const ResolverDataLineageSchema: GenMessage<ResolverDataLineage> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 38);

/**
 * @generated from message chalk.server.v1.GetDataLineageIndexRequest
 */
export type GetDataLineageIndexRequest = Message<"chalk.server.v1.GetDataLineageIndexRequest"> & {
};

/**
 * Describes the message chalk.server.v1.GetDataLineageIndexRequest.
 * Use `create(GetDataLineageIndexRequestSchema)` to create a new message.
 */
export const GetDataLineageIndexRequestSchema: GenMessage<GetDataLineageIndexRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 39);

/**
 * @generated from message chalk.server.v1.GetDataLineageIndexResponse
 */
export type GetDataLineageIndexResponse = Message<"chalk.server.v1.GetDataLineageIndexResponse"> & {
  /**
   * @generated from field: map<string, chalk.server.v1.ResolverDataLineage> resolver_data_lineage = 1;
   */
  resolverDataLineage: { [key: string]: ResolverDataLineage };
};

/**
 * Describes the message chalk.server.v1.GetDataLineageIndexResponse.
 * Use `create(GetDataLineageIndexResponseSchema)` to create a new message.
 */
export const GetDataLineageIndexResponseSchema: GenMessage<GetDataLineageIndexResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 40);

/**
 * What one scheduled query touches, read off the latest query plan it ran.
 *
 * The plan -- not the cron's declared `output` list -- is the source of truth
 * here: `output` names what was asked for, while the plan names every resolver
 * the planner actually ran and every feature it produced, which is what the
 * lineage graph is keyed on.
 *
 * @generated from message chalk.server.v1.ScheduledQueryLineage
 */
export type ScheduledQueryLineage = Message<"chalk.server.v1.ScheduledQueryLineage"> & {
  /**
   * @generated from field: int32 cron_query_id = 1;
   */
  cronQueryId: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string cron = 3;
   */
  cron: string;

  /**
   * Resolvers the latest plan ran, by fully-qualified name.
   *
   * @generated from field: repeated string resolver_fqns = 4;
   */
  resolverFqns: string[];

  /**
   * Features those resolvers produced, by fully-qualified name.
   *
   * @generated from field: repeated string feature_fqns = 5;
   */
  featureFqns: string[];

  /**
   * The plan the two lists above were read from.
   *
   * @generated from field: string query_plan_id = 6;
   */
  queryPlanId: string;
};

/**
 * Describes the message chalk.server.v1.ScheduledQueryLineage.
 * Use `create(ScheduledQueryLineageSchema)` to create a new message.
 */
export const ScheduledQueryLineageSchema: GenMessage<ScheduledQueryLineage> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 41);

/**
 * @generated from message chalk.server.v1.GetScheduledQueryLineageIndexRequest
 */
export type GetScheduledQueryLineageIndexRequest = Message<"chalk.server.v1.GetScheduledQueryLineageIndexRequest"> & {
};

/**
 * Describes the message chalk.server.v1.GetScheduledQueryLineageIndexRequest.
 * Use `create(GetScheduledQueryLineageIndexRequestSchema)` to create a new message.
 */
export const GetScheduledQueryLineageIndexRequestSchema: GenMessage<GetScheduledQueryLineageIndexRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 42);

/**
 * @generated from message chalk.server.v1.GetScheduledQueryLineageIndexResponse
 */
export type GetScheduledQueryLineageIndexResponse = Message<"chalk.server.v1.GetScheduledQueryLineageIndexResponse"> & {
  /**
   * Keyed by scheduled query name.
   *
   * @generated from field: map<string, chalk.server.v1.ScheduledQueryLineage> scheduled_queries = 1;
   */
  scheduledQueries: { [key: string]: ScheduledQueryLineage };

  /**
   * Names of active scheduled queries whose latest plan could not be read --
   * never run, failed before planning, or aged out of the plan store. The UI
   * says how many rather than letting a partial graph read as a complete one.
   *
   * @generated from field: repeated string names_without_plan = 2;
   */
  namesWithoutPlan: string[];
};

/**
 * Describes the message chalk.server.v1.GetScheduledQueryLineageIndexResponse.
 * Use `create(GetScheduledQueryLineageIndexResponseSchema)` to create a new message.
 */
export const GetScheduledQueryLineageIndexResponseSchema: GenMessage<GetScheduledQueryLineageIndexResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 43);

/**
 * Offline Store Table types
 *
 * @generated from message chalk.server.v1.OfflineTable
 */
export type OfflineTable = Message<"chalk.server.v1.OfflineTable"> & {
  /**
   * @generated from field: int32 internal_version = 1;
   */
  internalVersion: number;

  /**
   * @generated from field: string table_name = 2;
   */
  tableName: string;

  /**
   * @generated from field: string fqn = 3;
   */
  fqn: string;
};

/**
 * Describes the message chalk.server.v1.OfflineTable.
 * Use `create(OfflineTableSchema)` to create a new message.
 */
export const OfflineTableSchema: GenMessage<OfflineTable> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 44);

/**
 * @generated from message chalk.server.v1.GetOfflineStoreTableRequest
 */
export type GetOfflineStoreTableRequest = Message<"chalk.server.v1.GetOfflineStoreTableRequest"> & {
  /**
   * @generated from field: string fqn = 1;
   */
  fqn: string;

  /**
   * @generated from field: optional string branch_id = 2;
   */
  branchId?: string;
};

/**
 * Describes the message chalk.server.v1.GetOfflineStoreTableRequest.
 * Use `create(GetOfflineStoreTableRequestSchema)` to create a new message.
 */
export const GetOfflineStoreTableRequestSchema: GenMessage<GetOfflineStoreTableRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 45);

/**
 * @generated from message chalk.server.v1.GetOfflineStoreTableResponse
 */
export type GetOfflineStoreTableResponse = Message<"chalk.server.v1.GetOfflineStoreTableResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.OfflineTable tables = 1;
   */
  tables: OfflineTable[];
};

/**
 * Describes the message chalk.server.v1.GetOfflineStoreTableResponse.
 * Use `create(GetOfflineStoreTableResponseSchema)` to create a new message.
 */
export const GetOfflineStoreTableResponseSchema: GenMessage<GetOfflineStoreTableResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 46);

/**
 * @generated from message chalk.server.v1.GetAllOfflineStoreTablesPageToken
 */
export type GetAllOfflineStoreTablesPageToken = Message<"chalk.server.v1.GetAllOfflineStoreTablesPageToken"> & {
  /**
   * @generated from field: string fqn = 1;
   */
  fqn: string;

  /**
   * @generated from field: int32 internal_version = 2;
   */
  internalVersion: number;
};

/**
 * Describes the message chalk.server.v1.GetAllOfflineStoreTablesPageToken.
 * Use `create(GetAllOfflineStoreTablesPageTokenSchema)` to create a new message.
 */
export const GetAllOfflineStoreTablesPageTokenSchema: GenMessage<GetAllOfflineStoreTablesPageToken> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 47);

/**
 * @generated from message chalk.server.v1.GetAllOfflineStoreTablesRequest
 */
export type GetAllOfflineStoreTablesRequest = Message<"chalk.server.v1.GetAllOfflineStoreTablesRequest"> & {
  /**
   * @generated from field: string deployment_id = 1;
   */
  deploymentId: string;

  /**
   * keep for wire-compat; no longer read
   *
   * @generated from field: optional string branch_id = 2 [deprecated = true];
   * @deprecated
   */
  branchId?: string;

  /**
   * @generated from field: optional int32 limit = 3;
   */
  limit?: number;

  /**
   * Must be encoded GetAllOfflineStoreTablesPageToken
   * see https://protobuf.dev/best-practices/api/#define-pagination-api
   *
   * @generated from field: optional string page_token = 4;
   */
  pageToken?: string;
};

/**
 * Describes the message chalk.server.v1.GetAllOfflineStoreTablesRequest.
 * Use `create(GetAllOfflineStoreTablesRequestSchema)` to create a new message.
 */
export const GetAllOfflineStoreTablesRequestSchema: GenMessage<GetAllOfflineStoreTablesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 48);

/**
 * @generated from message chalk.server.v1.GetAllOfflineStoreTablesResponse
 */
export type GetAllOfflineStoreTablesResponse = Message<"chalk.server.v1.GetAllOfflineStoreTablesResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.OfflineTable tables = 1;
   */
  tables: OfflineTable[];

  /**
   * @generated from field: optional string next_page_token = 2;
   */
  nextPageToken?: string;
};

/**
 * Describes the message chalk.server.v1.GetAllOfflineStoreTablesResponse.
 * Use `create(GetAllOfflineStoreTablesResponseSchema)` to create a new message.
 */
export const GetAllOfflineStoreTablesResponseSchema: GenMessage<GetAllOfflineStoreTablesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 49);

/**
 * @generated from message chalk.server.v1.DiffDeploymentsRequest
 */
export type DiffDeploymentsRequest = Message<"chalk.server.v1.DiffDeploymentsRequest"> & {
  /**
   * @generated from field: optional string deployment_id_before = 1;
   */
  deploymentIdBefore?: string;

  /**
   * @generated from field: string deployment_id_after = 2;
   */
  deploymentIdAfter: string;

  /**
   * Defaults to DIFF_MODE_FULL when unset.
   *
   * @generated from field: chalk.server.v1.DiffMode diff_mode = 3;
   */
  diffMode: DiffMode;
};

/**
 * Describes the message chalk.server.v1.DiffDeploymentsRequest.
 * Use `create(DiffDeploymentsRequestSchema)` to create a new message.
 */
export const DiffDeploymentsRequestSchema: GenMessage<DiffDeploymentsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 50);

/**
 * @generated from message chalk.server.v1.DiffDeploymentsResponse
 */
export type DiffDeploymentsResponse = Message<"chalk.server.v1.DiffDeploymentsResponse"> & {
  /**
   * @generated from field: optional string deploy_id_before = 1;
   */
  deployIdBefore?: string;

  /**
   * @generated from field: string deploy_id_after = 2;
   */
  deployIdAfter: string;

  /**
   * @generated from field: chalk.artifacts.v1.ExportDiff diff = 3;
   */
  diff?: ExportDiff;
};

/**
 * Describes the message chalk.server.v1.DiffDeploymentsResponse.
 * Use `create(DiffDeploymentsResponseSchema)` to create a new message.
 */
export const DiffDeploymentsResponseSchema: GenMessage<DiffDeploymentsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 51);

/**
 * @generated from message chalk.server.v1.SmartDiffDeploymentRequest
 */
export type SmartDiffDeploymentRequest = Message<"chalk.server.v1.SmartDiffDeploymentRequest"> & {
  /**
   * @generated from field: string deployment_id = 1;
   */
  deploymentId: string;

  /**
   * Defaults to DIFF_MODE_FULL when unset.
   *
   * @generated from field: chalk.server.v1.DiffMode diff_mode = 2;
   */
  diffMode: DiffMode;
};

/**
 * Describes the message chalk.server.v1.SmartDiffDeploymentRequest.
 * Use `create(SmartDiffDeploymentRequestSchema)` to create a new message.
 */
export const SmartDiffDeploymentRequestSchema: GenMessage<SmartDiffDeploymentRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 52);

/**
 * @generated from message chalk.server.v1.SmartDiffDeploymentResponse
 */
export type SmartDiffDeploymentResponse = Message<"chalk.server.v1.SmartDiffDeploymentResponse"> & {
  /**
   * nil if no comparison target found
   *
   * @generated from field: optional string deploy_id_before = 1;
   */
  deployIdBefore?: string;

  /**
   * @generated from field: string deploy_id_after = 2;
   */
  deployIdAfter: string;

  /**
   * @generated from field: chalk.artifacts.v1.ExportDiff diff = 3;
   */
  diff?: ExportDiff;
};

/**
 * Describes the message chalk.server.v1.SmartDiffDeploymentResponse.
 * Use `create(SmartDiffDeploymentResponseSchema)` to create a new message.
 */
export const SmartDiffDeploymentResponseSchema: GenMessage<SmartDiffDeploymentResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 53);

/**
 * @generated from message chalk.server.v1.DiffCandidateRequest
 */
export type DiffCandidateRequest = Message<"chalk.server.v1.DiffCandidateRequest"> & {
  /**
   * The candidate export to diff against the latest successful deployment.
   *
   * @generated from field: chalk.artifacts.v1.Export candidate = 1;
   */
  candidate?: Export;

  /**
   * Defaults to DIFF_MODE_FULL when unset.
   *
   * @generated from field: chalk.server.v1.DiffMode diff_mode = 2;
   */
  diffMode: DiffMode;
};

/**
 * Describes the message chalk.server.v1.DiffCandidateRequest.
 * Use `create(DiffCandidateRequestSchema)` to create a new message.
 */
export const DiffCandidateRequestSchema: GenMessage<DiffCandidateRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 54);

/**
 * @generated from message chalk.server.v1.DiffCandidateResponse
 */
export type DiffCandidateResponse = Message<"chalk.server.v1.DiffCandidateResponse"> & {
  /**
   * The deployment the candidate was compared against. nil if no successful
   * deployment exists yet, in which case the diff reports the entire candidate
   * as added.
   *
   * @generated from field: optional string deploy_id_before = 1;
   */
  deployIdBefore?: string;

  /**
   * @generated from field: chalk.artifacts.v1.ExportDiff diff = 2;
   */
  diff?: ExportDiff;
};

/**
 * Describes the message chalk.server.v1.DiffCandidateResponse.
 * Use `create(DiffCandidateResponseSchema)` to create a new message.
 */
export const DiffCandidateResponseSchema: GenMessage<DiffCandidateResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_graph, 55);

/**
 * DiffMode controls how deeply DiffDeployments and SmartDiffDeployment compare graphs.
 *
 * FULL is the historical behavior — every field on every graph entity is
 * compared. SIMPLE restricts the diff to a hand-picked subset of fields that
 * summarize the user-visible shape of a deployment: feature sets and their
 * features (excluding internal/derived fields), resolver bodies, and charts.
 * All other top-level collections (sources, sinks, crons, etc.) are skipped
 * entirely in SIMPLE mode.
 *
 * @generated from enum chalk.server.v1.DiffMode
 */
export enum DiffMode {
  /**
   * @generated from enum value: DIFF_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Compare every field on every entity (historical default).
   *
   * @generated from enum value: DIFF_MODE_FULL = 1;
   */
  FULL = 1,

  /**
   * Compare only a curated whitelist of fields. See `diff.go` for the list.
   *
   * @generated from enum value: DIFF_MODE_SIMPLE = 2;
   */
  SIMPLE = 2,
}

/**
 * Describes the enum chalk.server.v1.DiffMode.
 */
export const DiffModeSchema: GenEnum<DiffMode> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_graph, 0);

/**
 * @generated from service chalk.server.v1.GraphService
 */
export const GraphService: GenService<{
  /**
   * GetFeatureSQL returns the feature SQLs for a given deployment.
   *
   * @generated from rpc chalk.server.v1.GraphService.GetFeatureSQL
   */
  getFeatureSQL: {
    methodKind: "unary";
    input: typeof GetFeatureSQLRequestSchema;
    output: typeof GetFeatureSQLResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.GraphService.GetFeaturesMetadata
   */
  getFeaturesMetadata: {
    methodKind: "unary";
    input: typeof GetFeaturesMetadataRequestSchema;
    output: typeof GetFeaturesMetadataResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.GraphService.GetGraph
   */
  getGraph: {
    methodKind: "unary";
    input: typeof GetGraphRequestSchema;
    output: typeof GetGraphResponseSchema;
  },
  /**
   * GetResolver returns a single resolver. Pass a read_mask to fetch just the
   * large sub-trees (e.g. postprocessing) that GetGraph omits from the bulk payload.
   *
   * @generated from rpc chalk.server.v1.GraphService.GetResolver
   */
  getResolver: {
    methodKind: "unary";
    input: typeof GetResolverRequestSchema;
    output: typeof GetResolverResponseSchema;
  },
  /**
   * GetStreamResolver returns a single stream resolver. Pass a read_mask to fetch
   * just the large sub-trees (e.g. parse_info) that GetGraph omits from the bulk payload.
   *
   * @generated from rpc chalk.server.v1.GraphService.GetStreamResolver
   */
  getStreamResolver: {
    methodKind: "unary";
    input: typeof GetStreamResolverRequestSchema;
    output: typeof GetStreamResolverResponseSchema;
  },
  /**
   * UpdateGraph uploads the protobuf graph for a given deployment.
   *
   * @generated from rpc chalk.server.v1.GraphService.UpdateGraph
   */
  updateGraph: {
    methodKind: "unary";
    input: typeof UpdateGraphRequestSchema;
    output: typeof UpdateGraphResponseSchema;
  },
  /**
   * GetCodegenFeaturesFromGraph returns Chalk features generated from the protograph
   *
   * @generated from rpc chalk.server.v1.GraphService.GetCodegenFeaturesFromGraph
   */
  getCodegenFeaturesFromGraph: {
    methodKind: "unary";
    input: typeof GetCodegenFeaturesFromGraphRequestSchema;
    output: typeof GetCodegenFeaturesFromGraphResponseSchema;
  },
  /**
   * ApplyGraphUpdates applies a series of mutations to a deployment's graph
   *
   * @generated from rpc chalk.server.v1.GraphService.ApplyGraphUpdates
   */
  applyGraphUpdates: {
    methodKind: "unary";
    input: typeof ApplyGraphUpdatesRequestSchema;
    output: typeof ApplyGraphUpdatesResponseSchema;
  },
  /**
   * TestGraphMutations applies a series of mutations to a deployment's graph without persisting state
   * This allows testing graph updates before actually applying them
   *
   * @generated from rpc chalk.server.v1.GraphService.TestGraphMutations
   */
  testGraphMutations: {
    methodKind: "unary";
    input: typeof TestGraphMutationsRequestSchema;
    output: typeof TestGraphMutationsResponseSchema;
  },
  /**
   * GetDataLineageIndex returns a mapping of resolver names to their data lineage information
   *
   * @generated from rpc chalk.server.v1.GraphService.GetDataLineageIndex
   */
  getDataLineageIndex: {
    methodKind: "unary";
    input: typeof GetDataLineageIndexRequestSchema;
    output: typeof GetDataLineageIndexResponseSchema;
  },
  /**
   * GetScheduledQueryLineageIndex returns, for each scheduled query active on
   * the environment's active deployment, the resolvers and features its latest
   * query plan ran. Companion to GetDataLineageIndex: the resolver names line
   * up, so the lineage graph can hang scheduled queries off the features they
   * compute.
   *
   * @generated from rpc chalk.server.v1.GraphService.GetScheduledQueryLineageIndex
   */
  getScheduledQueryLineageIndex: {
    methodKind: "unary";
    input: typeof GetScheduledQueryLineageIndexRequestSchema;
    output: typeof GetScheduledQueryLineageIndexResponseSchema;
  },
  /**
   * GetOfflineStoreTable returns the offline store table names for a feature
   *
   * @generated from rpc chalk.server.v1.GraphService.GetOfflineStoreTable
   */
  getOfflineStoreTable: {
    methodKind: "unary";
    input: typeof GetOfflineStoreTableRequestSchema;
    output: typeof GetOfflineStoreTableResponseSchema;
  },
  /**
   * GetAllOfflineStoreTables returns the offline store table name for every
   * feature and internal version in the deployment. Useful for reverse-mapping
   * a feat_<hash> table name back to its feature.
   *
   * @generated from rpc chalk.server.v1.GraphService.GetAllOfflineStoreTables
   */
  getAllOfflineStoreTables: {
    methodKind: "unary";
    input: typeof GetAllOfflineStoreTablesRequestSchema;
    output: typeof GetAllOfflineStoreTablesResponseSchema;
  },
  /**
   * DiffDeployments compares two deployment graphs and returns the diff.
   *
   * @generated from rpc chalk.server.v1.GraphService.DiffDeployments
   */
  diffDeployments: {
    methodKind: "unary";
    input: typeof DiffDeploymentsRequestSchema;
    output: typeof DiffDeploymentsResponseSchema;
  },
  /**
   * SmartDiffDeployment automatically finds the best comparison target and diffs.
   *
   * @generated from rpc chalk.server.v1.GraphService.SmartDiffDeployment
   */
  smartDiffDeployment: {
    methodKind: "unary";
    input: typeof SmartDiffDeploymentRequestSchema;
    output: typeof SmartDiffDeploymentResponseSchema;
  },
  /**
   * DiffCandidate compares a candidate export against the latest successful
   * deployment's graph and returns the diff.
   *
   * @generated from rpc chalk.server.v1.GraphService.DiffCandidate
   */
  diffCandidate: {
    methodKind: "unary";
    input: typeof DiffCandidateRequestSchema;
    output: typeof DiffCandidateResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chalk_server_v1_graph, 0);

